import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, Menu } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
// import { useStore } from 'src/stores';
import useStyles from './styles';
export const TeamMemberMenu = observer(_ref => {
  let selectedTeamMember = _ref.selectedTeamMember,
    menuTriggerExternal = _ref.menuTriggerExternal,
    handleShowEditTeamMemberModal = _ref.handleShowEditTeamMemberModal,
    handleShowTransferOwnershipModal = _ref.handleShowTransferOwnershipModal,
    handleShowDeleteTeamMemberModal = _ref.handleShowDeleteTeamMemberModal,
    setModalTeamMemberData = _ref.setModalTeamMemberData;
  const classes = useStyles();
  // const navigate = useNavigate();
  // const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const MenuTriggerInternal = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t('general.to_do')), /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }));
  };
  return /*#__PURE__*/React.createElement("span", {
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0,
    'custom-attribute': '837-team-settings-page-my-team-dash-menu'
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.todoDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '838-team-settings-page-my-team-dash-menu'
  }, menuTriggerExternal !== undefined ? menuTriggerExternal : /*#__PURE__*/React.createElement(MenuTriggerInternal, null)), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    disabled: handleShowEditTeamMemberModal === undefined,
    onClick: event => {
      if (handleShowEditTeamMemberModal !== undefined) {
        event.stopPropagation();
        setModalTeamMemberData(selectedTeamMember);
        handleClose();
        handleShowEditTeamMemberModal(true);
      }
    },
    'custom-attribute': '839-team-settings-page-my-team-dash-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('team_page.edit_team_member')), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    disabled: handleShowTransferOwnershipModal === undefined,
    onClick: event => {
      if (handleShowTransferOwnershipModal !== undefined) {
        event.stopPropagation();
        setModalTeamMemberData(selectedTeamMember);
        handleClose();
        handleShowTransferOwnershipModal(true);
      }
    },
    'custom-attribute': '840-team-settings-page-my-team-dash-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "access-handover-key"
  }), t('team_page.transfer_ownership')), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    disabled: handleShowDeleteTeamMemberModal === undefined,
    onClick: event => {
      if (handleShowDeleteTeamMemberModal !== undefined) {
        event.stopPropagation();
        setModalTeamMemberData(selectedTeamMember);
        handleClose();
        handleShowDeleteTeamMemberModal(true);
      }
    },
    'custom-attribute': '841-team-settings-page-my-team-dash-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  }), t('team_page.delete_team_member'))));
});